import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { Http } from '@angular/http';
import { LoaderService } from '../loader/loader.service';
import 'rxjs/add/operator/finally';
import { Notificacao } from '../../pages/notificacoes/notificacao';

@Injectable()
export class NotificacaoService {

	apiUrl:string;
	constructor(private router: Router, private http: HttpClient, private loader: LoaderService) {
		this.apiUrl = environment.apiUrl;
	}

	carregar(id:number){
		this.loader.show();
		return this.http.get<Notificacao>(this.apiUrl + "/notificacao/"+id).finally(()=>{
			this.loader.hide();
		});
	}
	
	atualizar(Notificacao:Notificacao){
		this.loader.show();
		return this.http.put(this.apiUrl+"/notificacao",Notificacao).finally(()=>{
			this.loader.hide();
		});
	}

    ListarPorUsuario(){
        return this.http.get<Notificacao[]>(this.apiUrl + "/notificacao/usuario").finally(()=>{
		});
    }

    QuantidadePorUsuario(){
        return this.http.get<Notificacao[]>(this.apiUrl + "/notificacao/usuario/nao-lidas").finally(()=>{
		});
    }


    deletar(id:number){
		this.loader.show();
		return this.http.delete(this.apiUrl+"/notificacao/"+id).finally(()=>{
			this.loader.hide();
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/services/notificacao/notificacao.service.ts